import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getVisibleAccounts, getFilters, getPagination, getIsLoading } from 'accounts/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as Accounts from 'accounts/components';
import AccountRowContainer from 'accounts/containers/AccountRowContainer';
import AccountsListHandlers from 'accounts/containers/AccountsListHandlers';

import { toggle } from 'accounts/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class AccountsListContainer extends Component {
  renderRows = () =>
    this.props.accounts.map((account) => (
      <AccountRowContainer key={account.id} account={account} handleToggle={this.handleToggle} />
    ));

  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <AccountsListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Accounts.ListView
          count={this.props.accounts.length}
          filters={this.props.filters}
          company={this.props.company}
          handleToggle={this.handleToggle}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Accounts.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  accounts: getVisibleAccounts(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(AccountsListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/AccountsListContainer.js